/*
 * ARL storefront core helpers.
 * Local, dependency-free browser utilities used by the theme's own assets.
 */
(function () {
  'use strict';

  const FOCUSABLE_SELECTOR = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'object:not([tabindex^="-"])',
    'embed:not([tabindex^="-"])',
    '[contenteditable]:not([contenteditable="false"]):not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  function isVisible(element) {
    if (!element || !(element instanceof Element)) return false;
    const style = window.getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
  }

  window.getFocusableElements = function getFocusableElements(container) {
    if (!container || !container.querySelectorAll) return [];
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  };

  let focusTrap = null;

  window.removeTrapFocus = function removeTrapFocus(elementToFocus) {
    if (focusTrap) {
      document.removeEventListener('focusin', focusTrap.onFocusIn);
      document.removeEventListener('keydown', focusTrap.onKeyDown);
      focusTrap = null;
    }

    if (elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
  };

  window.trapFocus = function trapFocus(container, elementToFocus) {
    if (!container) return;

    window.removeTrapFocus();

    const focusable = window.getFocusableElements(container);
    const first = focusable[0] || container;
    const last = focusable[focusable.length - 1] || first;
    const initial = elementToFocus || first;

    const onFocusIn = function (event) {
      if (event.target !== container && !container.contains(event.target)) {
        first.focus();
      }
    };

    const onKeyDown = function (event) {
      if (event.key !== 'Tab' && event.keyCode !== 9) return;

      if (focusable.length === 0) {
        event.preventDefault();
        if (typeof container.focus === 'function') container.focus();
        return;
      }

      if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    focusTrap = { onFocusIn, onKeyDown };
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('keydown', onKeyDown);

    window.requestAnimationFrame(function () {
      if (initial && typeof initial.focus === 'function') initial.focus();
    });
  };

  window.pauseAllMedia = function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(function (iframe) {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
      } catch (error) {}
    });

    document.querySelectorAll('.js-vimeo').forEach(function (iframe) {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      } catch (error) {}
    });

    document.querySelectorAll('video').forEach(function (video) {
      try { video.pause(); } catch (error) {}
    });

    document.querySelectorAll('product-model model-viewer, model-viewer').forEach(function (model) {
      try {
        if (model.modelViewerUI && typeof model.modelViewerUI.pause === 'function') {
          model.modelViewerUI.pause();
        }
      } catch (error) {}
    });
  };

  window.debounce = function debounce(callback, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        callback.apply(context, args);
      }, wait);
    };
  };

  window.onKeyUpEscape = function onKeyUpEscape(event) {
    if (!event || String(event.code || event.key || '').toUpperCase() !== 'ESCAPE') return;

    const openDetails = event.target && event.target.closest ? event.target.closest('details[open]') : null;
    if (!openDetails) return;

    const summary = openDetails.querySelector('summary');
    openDetails.removeAttribute('open');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
      summary.focus();
    }
  };

  window.fetchConfig = window.fetchConfig || function fetchConfig(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };
})();
